module.exports = "/_next/static/images/game-3-fingerprints-border-5a6fa56d3e2435a738d9675db7a43083.png";